import { createRoot } from 'react-dom/client';

import "./index.css";
import { Provider } from "react-redux";

import * as Sentry from "@sentry/react";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { PostHogProvider } from 'posthog-js/react'

import App from "./App";
import { store } from "./app/store/store";
import reportWebVitals from "./reportWebVitals";
import ENV from './app/constants/env';
const { PUBLIC_POSTHOG_HOST, PUBLIC_POSTHOG_KEY } = ENV;

function FallbackComponent() {
  return <div>An error has occurred</div>;
}

const myFallback = <FallbackComponent />;
const documentRoot = document.getElementById('root');
const root = createRoot(documentRoot);
const options = {
  api_host: PUBLIC_POSTHOG_HOST,
  disable_session_recording: true,
}
const renderApp = async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SECRET,
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  });

  root.render(
    <PostHogProvider
      apiKey={PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <Provider store={store}>
        <LDProvider>
          <Sentry.ErrorBoundary fallback={myFallback} showDialog>
            <App />
          </Sentry.ErrorBoundary>
        </LDProvider>
      </Provider>
    </PostHogProvider>
  );
};
renderApp();

// serviceWorkerRegistration.register()

reportWebVitals();
